import React, { useState } from 'react';
import { useRouter } from 'next/router';

const SubMenu = (props) => {
    const router = useRouter();
    const handleMenuClick = (menu) => {
        if (menu.children) return;
        if (menu.link) {
            window.open(menu.link, '_blank');
        } else {
            if (menu.type === 1) router.push('/more/' + menu.id + '?page=1');
            router.push('/menus/' + menu.id);
        }
    };

    return (
        <li className="rounded-sm relative px-3 py-1 hover:bg-gray-100">
            <button
                onClick={() => handleMenuClick(props)}
                className="w-full text-left flex items-center outline-none focus:outline-none"
            >
                <span className="pr-1 flex-1 menuname">{props.name}</span>
            </button>
            <ul
                className="bg-white border rounded-sm absolute top-0 right-0 
  transition duration-150 ease-in-out origin-top-left
  min-w-32
  "
            >
                {props.children &&
                    props.children.map((children) => {
                        return (
                            <li
                                key={children.id}
                                onClick={() => handleMenuClick(children)}
                                className="px-3 py-1 hover:bg-gray-100 menuname"
                            >
                                {children.name}
                            </li>
                        );
                    })}
            </ul>
        </li>
    );
};

const Dropdown = (props) => {
    const router = useRouter();
    const [isActive, setActive] = useState(false);

    const handleMouseOver = () => setActive(true);

    const handleMouseLeave = () => setActive(false);

    const handleMenuClick = (menu) => {
        if (menu.children) return;
        if (menu.link) {
            window.open(menu.link, '_blank');
        } else {
            if (menu.type === 1) router.push('/more/' + menu.id + '?page=1');
            router.push('/menus/' + menu.id);
        }
        setActive(false);
    };

    return (
        <div
            className="group inline-block navbar"
            onMouseEnter={handleMouseOver}
            onMouseLeave={handleMouseLeave}
        >
            <div className="outline-none focus:outline-none px-3 py-1 bg-white rounded-sm flex items-center min-w-32">
                <span
                    className="pr-1 font-semibold flex-1 menuname"
                    onClick={() => handleMenuClick(props.menu)}
                >
                    {props.menu.name}
                </span>
            </div>
            {isActive && (
                <ul
                    className="bg-white rounded-sm transform scale-0 group-hover:scale-100 absolute 
  transition duration-150 ease-in-out origin-top min-w-32"
                    style={{ border: '1px solid #e9e9e9', zIndex: 200000 }}
                >
                    {props.menu.children &&
                        props.menu.children.map((children) => {
                            if (children.children) return <SubMenu {...children} />;
                            return (
                                <li
                                    key={children.id}
                                    className="rounded-sm px-3 py-1 hover:bg-gray-100 menuname"
                                    onClick={() => handleMenuClick(children)}
                                >
                                    {children.name}
                                </li>
                            );
                        })}
                </ul>
            )}
        </div>
    );
};

Dropdown.defaultProps = {
    menu: {
        id: 1,
        name: 'Танилцуулга',
        children: [
            {
                id: 2,
                name: 'Бидний тухай',
                link: null,
                children: [
                    {
                        id: 2,
                        name: 'Төсөл хөтөлбөрүүд',
                        link: null,
                    },
                    {
                        id: 3,
                        name: 'Мэдээ мэдээлэл',
                        link: null,
                    },
                ],
            },
            {
                id: 3,
                name: 'Шилэн данс',
                link: null,
            },
            {
                id: 3,
                name: 'Гадаад мэдээ',
                link: null,
            },
            {
                id: 3,
                name: 'Холбоо барих',
                link: null,
            },
        ],
    },
};

export default Dropdown;
